import { WALKING_SPEED, MAX_DISTANCE, MAX_CHANGE, ENTRANCE_HEIGHT } from '../enums/model.enums';
/**
 * class {UserPreferences}
 * should be used to display preference related information
 */
export class UserPreferences {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param preferredMotTypes
     * @param preferredDistance
     * @param preferredWalkingSpeed
     * @param preferredMaxChanges
     * @param preferredEntranceHeight
     * @param mobilityImpairments
     */
    constructor(id, preferredMotTypes, preferredDistance, preferredWalkingSpeed, preferredMaxChanges, preferredEntranceHeight, mobilityImpairments) {
        this._id = id;
        this._preferredMotTypes = preferredMotTypes;
        this._preferredDistance = preferredDistance;
        this._preferredWalkingSpeed = preferredWalkingSpeed;
        this._preferredMaxChanges = preferredMaxChanges;
        this._preferredEntranceHeight = preferredEntranceHeight;
        this._mobilityImpairments = mobilityImpairments;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Mot}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.preferredMotTypes = values.preferredMotTypes || [];
        sanitizedValues.preferredDistance = values.preferredDistance || MAX_DISTANCE.ANY;
        sanitizedValues.preferredWalkingSpeed = values.preferredWalkingSpeed || WALKING_SPEED.NORMAL;
        sanitizedValues.preferredMaxChanges = values.preferredMaxChanges || MAX_CHANGE.ANY;
        sanitizedValues.preferredEntranceHeight = values.preferredEntranceHeight || ENTRANCE_HEIGHT.ANY;
        sanitizedValues.mobilityImpairments = values.mobilityImpairments || [];
        return new UserPreferences(sanitizedValues.id, sanitizedValues.preferredMotTypes, sanitizedValues.preferredDistance, sanitizedValues.preferredWalkingSpeed, sanitizedValues.preferredMaxChanges, sanitizedValues.preferredEntranceHeight, sanitizedValues.mobilityImpairments);
    }
    /**
     * gets the id of this obj
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the id of this obj
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets all by default chosen mot types
     * @returns {MOT_TYPE[]}
     */
    get preferredMotTypes() {
        return this._preferredMotTypes;
    }
    /**
     * sets all by default chosen mot types
     * @param value
     */
    set preferredMotTypes(value) {
        this._preferredMotTypes = value;
    }
    /**
     * gets the preferred distance from one stop to another
     * @returns {DISTANCE}
     */
    get preferredDistance() {
        return this._preferredDistance;
    }
    /**
     * sets the preferred distance from one stop to another
     * @param value
     */
    set preferredDistance(value) {
        this._preferredDistance = value;
    }
    /**
     * gets the preferred walking speed
     * @returns {WALKING_SPEED}
     */
    get preferredWalkingSpeed() {
        return this._preferredWalkingSpeed;
    }
    /**
     * sets the preferred walking speed
     * @param value
     */
    set preferredWalkingSpeed(value) {
        this._preferredWalkingSpeed = value;
    }
    /**
     * gets the maximum of changes for a connection
     * @returns {MAX_CHANGE}
     */
    get preferredMaxChanges() {
        return this._preferredMaxChanges;
    }
    /**
     * sets the maximum of changes for a connection
     * @param value
     */
    set preferredMaxChanges(value) {
        this._preferredMaxChanges = value;
    }
    /**
     * gets the entrance height e.g. to a bus or tram
     * @returns {ENTRANCE_HEIGHT}
     */
    get preferredEntranceHeight() {
        return this._preferredEntranceHeight;
    }
    /**
     * sets the entrance height e.g. to a bus or tram
     * @param value
     */
    set preferredEntranceHeight(value) {
        this._preferredEntranceHeight = value;
    }
    /**
     * gets all mobility impairments to be used for requests and/or display values
     * @returns {MOBILITY_IMPAIRMENT[]}
     */
    get mobilityImpairments() {
        return this._mobilityImpairments;
    }
    /**
     * sets all mobility impairments to be used for requests and/or display values
     * @param value
     */
    set mobilityImpairments(value) {
        this._mobilityImpairments = value;
    }
}
//# sourceMappingURL=userPreferences.js.map